import checkout from "./form2";

const {
  formField2: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    supportData,
    enterVoiceover,
  },
} = checkout;

const initialValues2 = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [supportData.name]: false,
  [enterVoiceover.name]: false,
};

export default initialValues2;
